import React from "react";

const HouseSvg = () => (
  <svg
    viewBox="0 0 132 113"
    css={`
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    `}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.814 7.022L9.212 46.895h.06v60.592h113.144V46.895L65.814 7.022z"
      fill="#EB9C46"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.448 59.5a16.845 16.845 0 0 0-5.61-11.98c2.482-8.914 10.66-15.459 20.368-15.459 7.741 0 14.512 4.16 18.197 10.365a30.742 30.742 0 0 0-5.281-.454c-12.223 0-22.773 7.165-27.674 17.528z"
      fill="#E48032"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M88.122 103.17c-12.213 0-22.757-7.157-27.664-17.508V68.353a21.078 21.078 0 0 0 11.694 5.776c1.93 8.121 9.229 14.16 17.941 14.16 10.185 0 18.441-8.256 18.441-18.442 0-7.991-5.083-14.795-12.192-17.355a21.02 21.02 0 0 0-2.939-10.066c14.385 2.501 25.322 15.042 25.322 30.144 0 16.903-13.7 30.6-30.603 30.6z"
      fill="#E8903E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.152 74.129a21.078 21.078 0 0 1-11.694-5.776v-8.255c0-.201-.004-.399-.01-.598 4.901-10.363 15.451-17.528 27.674-17.528 1.801 0 3.565.155 5.281.454a21.02 21.02 0 0 1 2.939 10.066 18.402 18.402 0 0 0-6.249-1.085c-10.186 0-18.441 8.255-18.441 18.44 0 1.474.173 2.908.5 4.282z"
      fill="#E0762D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.69 112.94h33.768v-5.453H26.69v5.453z"
      fill="#E6832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.458 107.487H26.69V60.098c0-9.325 7.561-16.885 16.882-16.885 4.33 0 8.278 1.628 11.266 4.307a21.12 21.12 0 0 0-.773 5.68c0 4.745 1.562 9.125 4.199 12.653a30.706 30.706 0 0 0-.74 6.717c0 4.685 1.053 9.123 2.934 13.092v21.825z"
      fill="#D7542B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.264 65.853A21.062 21.062 0 0 1 54.065 53.2c0-1.968.269-3.872.773-5.68a16.845 16.845 0 0 1 5.61 11.98 30.361 30.361 0 0 0-2.184 6.353z"
      fill="#D3482B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.458 85.662a30.487 30.487 0 0 1-2.934-13.092c0-2.308.256-4.556.74-6.717.666.89 1.399 1.726 2.194 2.5v17.309z"
      fill="#D64F2B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.458 68.353a21.292 21.292 0 0 1-2.194-2.5 30.361 30.361 0 0 1 2.184-6.353c.006.199.01.397.01.598v8.255z"
      fill="#D1442B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.759 55.441L0 47.266 65.814.906l65.812 46.36-5.759 8.175-3.451-2.43v-6.116L65.814 7.022 9.212 46.895h.06v6.072l-3.513 2.474z"
      fill="#E6832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M122.416 53.011L65.814 13.138 9.272 52.967v-6.072h-.06L65.814 7.022l56.602 39.873v6.116z"
      fill="#D7542B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.019 59.85a8.445 8.445 0 1 1-16.89 0 8.445 8.445 0 0 1 16.89 0zM108.534 69.847c0 10.186-8.256 18.442-18.441 18.442-10.186 0-18.441-8.256-18.441-18.442 0-10.185 8.255-18.44 18.441-18.44 10.185 0 18.441 8.255 18.441 18.44z"
      fill="#D6EDED"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M97.485 79.697a10.31 10.31 0 0 0 1.606-5.543c0-5.72-4.637-10.357-10.358-10.357-2.486 0-4.767.876-6.552 2.335 1.017-5.563 5.887-9.778 11.745-9.778 6.595 0 11.941 5.345 11.941 11.941 0 5.356-3.525 9.888-8.382 11.402z"
      fill="#B6DEDE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M88.733 84.512c-5.721 0-10.357-4.637-10.357-10.358 0-3.234 1.482-6.122 3.805-8.022a11.96 11.96 0 0 0-.196 2.163c0 6.596 5.345 11.942 11.941 11.942 1.239 0 2.435-.189 3.559-.54a10.349 10.349 0 0 1-8.752 4.815z"
      fill="#B6DEDE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M93.926 80.237c-6.596 0-11.941-5.346-11.941-11.942 0-.738.067-1.461.196-2.163a10.318 10.318 0 0 1 6.552-2.335c5.721 0 10.358 4.637 10.358 10.357a10.31 10.31 0 0 1-1.606 5.543c-1.124.351-2.32.54-3.559.54z"
      fill="#9AD3D3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71.652 89.29h36.882v-6.221H71.652v6.221z"
      fill="#E6832D"
    />
  </svg>
);

export default HouseSvg;
